module.exports = __webpack_public_path__ + "static/img/empty_empty.c57c4ca5.png";